// Централизованное in-memory хранилище access-токена
// Безопаснее, чем localStorage: токен исчезает при перезагрузке вкладки

let accessTokenMemory = null;

export function setAccessToken(token) {
  accessTokenMemory = typeof token === 'string' ? token : null;
}

export function getAccessToken() {
  return accessTokenMemory;
}

export function clearAccessToken() {
  accessTokenMemory = null;
}

// Мягкая миграция: однократно подтянуть токен из localStorage и очистить его
export function migrateFromLocalStorageOnce() {
  try {
    const lsToken = localStorage.getItem('access_token');
    if (lsToken && lsToken !== 'null' && lsToken !== 'undefined') {
      accessTokenMemory = lsToken;
    }
    // Не удаляем сразу user prefs
    localStorage.removeItem('access_token');
  } catch (_) {
    // ignore
  }
}


